var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-breadcrumbs'),_c('page-content',{attrs:{"page-title":"Benutzer bearbeiten"}},[_c('user-form',{attrs:{"loading":_vm.loading,"user":_vm.user,"form-submitted":_vm.saveUser,"mode":"edit"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }